import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const ManageChartOfAccountsViewChunk = lazy(() =>
  import('../feature-sets/ManageChartOfAccountsView').then(
    ({ ManageChartOfAccountsView }) => ({
      default: ManageChartOfAccountsView,
    })
  )
)

export const ManageChartOfAccountsPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.manageChartOfAccountsTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          link: '/settings/chartofaccounts',
          name: intl.formatMessage(messages.manageChartOfAccountsTitle),
        },
      ]}
    >
      <ManageChartOfAccountsViewChunk />
    </Page>
  )
}
